(function () {
  'use strict';

  var section = document.querySelector('.bundle-reviews');
  if (!section) return;

  var idsAttr = (section.getAttribute('data-bundle-product-ids') || '').trim();
  if (!idsAttr) return;

  var productIds = idsAttr
    .split(',')
    .map(function (s) { return parseInt(s, 10); })
    .filter(function (n) { return !isNaN(n); });
  if (productIds.length === 0) return;

  var valueEl = section.querySelector('[data-rating-value]');
  var countEl = section.querySelector('[data-rating-count]');
  var barsEl = section.querySelector('[data-rating-bars]');
  var listEl = section.querySelector('[data-review-list]');
  var showMoreBtn = section.querySelector('[data-show-more]');
  var cardTpl = section.querySelector('[data-review-card-tpl]');
  var noTextEl = section.querySelector('[data-no-text-state]');

  /* Empty-state branch: Liquid rendered [data-empty-state] because the bundle
     has zero ratings — nothing for JS to do. */
  var totalRatingCount = parseInt(section.getAttribute('data-total-rating-count'), 10);
  if (isNaN(totalRatingCount) || totalRatingCount === 0) return;

  if (!valueEl || !barsEl || !listEl || !cardTpl) return;

  var initialCount = parseInt(section.getAttribute('data-initial-count'), 10);
  if (isNaN(initialCount) || initialCount < 1) initialCount = 4;

  var groupedUrl = section.getAttribute('data-grouped-reviews-url');
  if (!groupedUrl) return;

  fetch(groupedUrl, { cache: 'force-cache' })
    .then(function (res) { return res.json(); })
    .then(function (all) {
      var idSet = {};
      productIds.forEach(function (id) { idSet[id] = true; });

      /* Only reviews with actual body text.
         Upstream (fetching_reviews.js) empties `b` when the body is too short
         or duplicates the product title, so a non-empty string == real text. */
      var reviews = all.filter(function (r) {
        return idSet[r.i] && (r.b || '').trim().length > 0;
      });

      if (reviews.length === 0) {
        /* Aggregate stays visible (Liquid renders it); only the cards area
           shows a hint that no written reviews are available yet. */
        if (noTextEl) noTextEl.hidden = false;
        return;
      }

      /* Newest first */
      reviews.sort(function (a, b) {
        return new Date(b.d).getTime() - new Date(a.d).getTime();
      });

      renderSummary(reviews);
      renderCards(reviews);
    })
    .catch(function () {
      /* On fetch/parse failure: aggregate already rendered by Liquid,
         show no-text hint so the cards area is not blank. */
      if (noTextEl) noTextEl.hidden = false;
    });

  function renderSummary(reviews) {
    /* Average and count are server-rendered by sections/bundle-reviews.liquid
       from the products' rating metafields — those include text-less reviews
       and would be clobbered here if we wrote back over them. */
    var buckets = [0, 0, 0, 0, 0, 0];
    reviews.forEach(function (r) {
      var rating = parseInt(r.r, 10);
      if (rating >= 1 && rating <= 5) buckets[rating] += 1;
    });

    barsEl.textContent = '';
    for (var star = 5; star >= 1; star--) {
      var pct = (buckets[star] / reviews.length) * 100;
      var pctText = pct.toFixed(2) + '%';

      var label = document.createElement('li');
      label.className = 'bundle-reviews__bar-label txt-label-m-bold';
      label.textContent = star + (star === 1 ? ' Stern' : ' Sterne');

      var track = document.createElement('li');
      track.className = 'bundle-reviews__bar-track';
      var fill = document.createElement('span');
      fill.className = 'bundle-reviews__bar-fill';
      fill.style.width = pctText;
      track.appendChild(fill);

      var pctEl = document.createElement('li');
      pctEl.className = 'bundle-reviews__bar-pct txt-body-s-regular';
      pctEl.textContent = pctText;

      barsEl.appendChild(label);
      barsEl.appendChild(track);
      barsEl.appendChild(pctEl);
    }
  }

  function formatDate(value) {
    if (!value) return '';
    var d = new Date(value);
    if (isNaN(d.getTime())) return '';
    var day = String(d.getDate()).padStart(2, '0');
    var month = String(d.getMonth() + 1).padStart(2, '0');
    return day + '.' + month + '.' + d.getFullYear();
  }

  function renderCards(reviews) {
    var fragment = document.createDocumentFragment();

    reviews.forEach(function (r, i) {
      var node = cardTpl.content.firstElementChild.cloneNode(true);
      if (i >= initialCount) node.classList.add('bundle-reviews__item--hidden');

      node.querySelector('[data-rating]').textContent = r.r;

      var dateEl = node.querySelector('[data-date]');
      var dateText = formatDate(r.d);
      if (dateText) dateEl.textContent = dateText;
      else dateEl.remove();

      var badgeEl = node.querySelector('[data-badge]');
      badgeEl.textContent = 'Verifizierter Kauf';
      badgeEl.hidden = false;

      var authorEl = node.querySelector('[data-author]');
      if (r.n) authorEl.textContent = 'von ' + r.n;
      else authorEl.remove();

      var body = (r.b || '').trim();
      var bodyEl = node.querySelector('[data-body]');
      var subEl = node.querySelector('[data-sub]');
      if (body) {
        bodyEl.textContent = body;
        bodyEl.hidden = false;
      } else if (r.t) {
        subEl.textContent = r.t;
        subEl.hidden = false;
      }

      fragment.appendChild(node);
    });

    listEl.appendChild(fragment);

    if (reviews.length > initialCount && showMoreBtn) {
      showMoreBtn.hidden = false;
      showMoreBtn.addEventListener('click', function () {
        var hidden = listEl.querySelectorAll('.bundle-reviews__item--hidden');
        for (var i = 0; i < hidden.length; i++) {
          hidden[i].classList.remove('bundle-reviews__item--hidden');
        }
        showMoreBtn.hidden = true;
      });
    }
  }
})();
